














import { defineComponent, ref } from '@vue/composition-api';
import type { PropType } from 'vue';
import type { VerifyLinkResponse } from '@getaccept/lib-shared/src/universal-link/types/verify-link-response';
import { t } from '@getaccept/lib-shared/src/helpers/translation.helper';
import { AuthenticationStepType } from '@getaccept/lib-shared/src/authentication/types/enums/authentication-step-type';
import Consents from './Consents.vue';
import IdentifyWrapper from './IdentifyWrapper.vue';
import UniversalForm from './UniversalForm.vue';

export default defineComponent({
  components: {
    Consents,
    IdentifyWrapper,
    UniversalForm,
  },
  props: {
    verifyLinkResponse: {
      type: Object as PropType<VerifyLinkResponse>,
      required: true,
    },
    logoUrl: {
      type: String,
      default: '',
    },
  },
  setup(props) {
    const entity = { name: props.verifyLinkResponse.entityName };
    const document = { name: props.verifyLinkResponse.documentName };
    const textData = { entity, document };

    const consentSteps = [
      {
        type: AuthenticationStepType.GdprConsent,
        data: {
          text: props.verifyLinkResponse.consentText,
          textData,
        },
      },
      {
        type: AuthenticationStepType.TrackingConsent,
        data: {
          text: props.verifyLinkResponse.trackingText,
          textData,
        },
      },
    ].filter(
      ({ type }) =>
        (type === AuthenticationStepType.GdprConsent &&
          props.verifyLinkResponse.requireGdprConsent) ||
        (type === AuthenticationStepType.TrackingConsent &&
          props.verifyLinkResponse.trackingConsent)
    );

    const showConsents = ref(true);
    const storedConsents = ref<{ type: AuthenticationStepType; value: string | boolean }[]>([]);

    const handleAnswer = (
      consents: {
        type: AuthenticationStepType;
        value: string | boolean;
      }[]
    ) => {
      storedConsents.value = consents;
      showConsents.value = false;
    };

    return {
      consentSteps,
      t,
      handleAnswer,
      showConsents,
      storedConsents,
    };
  },
});
